<template>
    <div>
        <rkm-row
            v-if="!hideFilters && !$slots['filters']"
        >
            <rkm-col
                :cols="showSortOptions && hasSortOptions ? '6' : '12'"
            >
                <rkm-form-input
                    placeholder="Digite para buscar"
                    v-model="model.filter"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text>Buscar</rkm-input-group-text>
                    </rkm-input-group-prepend>
                    <rkm-input-group-append slot="append">
                        <rkm-button
                            :disabled="!model.filter"
                            @click="handleClearFilter"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <template v-if="showSortOptions && hasSortOptions">
                <rkm-col
                    cols="6"
                >
                    <rkm-form-group
                        class="my-0"
                        label-cols="auto"
                        label="Ordenar"
                    >
                        <rkm-form-select
                            :options="sortOptions"
                            v-model="model.sortBy"
                            show-default-option
                        >

                            <template slot="append">
                                <rkm-form-select
                                    :disabled="!model.sortBy"
                                    v-model="model.sortDesc"
                                >
                                    <rkm-form-select-option :value="false">Asc</rkm-form-select-option>
                                    <rkm-form-select-option :value="true">Desc</rkm-form-select-option>
                                </rkm-form-select>
                            </template>
                        </rkm-form-select>
                    </rkm-form-group>
                </rkm-col>
            </template>
        </rkm-row>

        <slot name="filters" />

        <b-table
            :busy="busy"
            :current-page="model.currentPage"
            :fields="fields"
            :filter="model.filter"
            :items="items"
            :per-page="hidePagination ? null : model.perPage"
            :sort-by.sync="model.sortBy"
            :sort-desc.sync="model.sortDesc"
            :tbody-tr-attr="tbodyTrAttr"
            :tbody-tr-class="tbodyTrClass"
            @filtered="filtered"
            empty-filtered-text="Não há registros correspondentes à sua solicitação"
            empty-text="Não há registros para exibir"
            hover
            outlined
            ref="table"
            show-empty
            striped
            sort-icon-left
        >
            <template v-slot:table-busy>
                <div class="text-center">
                    <rkm-icon icon="circle-notch" loading /> carregando...
                </div>
            </template>

            <template #empty="scope"><div class="text-center">{{ scope.emptyText }}</div></template>
            <template #emptyfiltered="scope"><div class="text-center">{{ scope.emptyFilteredText }}</div></template>

            <template
                v-for="(_, name) in $scopedSlots"
                :slot="name"
                slot-scope="data"
            >
                <slot
                    :name="name"
                    v-bind="data"
                />
            </template>
        </b-table>


        <template v-if="!hidePagination">
            <rkm-row class="datatable-footer">
                <rkm-col>
                    <rkm-row class="align-items-center">
                        <rkm-col
                            cols="auto"
                        >
                            <b-pagination
                                :per-page="model.perPage"
                                :total-rows="model.totalRows"
                                v-model="model.currentPage"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-col>

                <rkm-col
                    cols="auto"
                >
                    <rkm-form-group
                        label-align="left"
                        label-cols="auto"
                        label="Por página"
                    >
                        <rkm-form-select
                            :options="pageOptions"
                            v-model="model.perPage"
                        />
                    </rkm-form-group>
                </rkm-col>
            </rkm-row>    
        </template>
    </div>
</template>

<script>
// Components.
import { BTable, BPagination } from 'bootstrap-vue'

export default {
    components: { BTable, BPagination },
    computed: {
        hasSortOptions() {
            return this.sortOptions.length > 0
        },
        sortOptions() {
            return this.fields.filter(field => !!field.sortable).map(field => {
                return { text: field.label, value: field.key }
            })
        },
        pageOptions() {
            return [10, 50, 100]
        },
    },
    data: () => ({
        model: {
            currentPage: 1,
            filter: null,
            perPage: 10,
            sortBy: null,
            sortDesc: false,
            totalRows: 0,
        },
    }),
    methods: {
        filtered(filteredItems) {
            this.model.totalRows = filteredItems.length
            this.model.currentPage = 1
        },
        handleClearFilter() {
            this.model.filter = null
        },
        refresh() {
            this.$refs.table.refresh()
        },
    },
    props: {
        busy: {type: Boolean},
        fields: {type: Array, required: true},
        filter: {type: String, default: null},
        hideFilters: {type: Boolean, default: false},
        hidePagination: {type: Boolean, default: false},
        items: {type: [Array], default: () => []},
        showSortOptions: {type: Boolean, default: false},
        sortBy: {type: String, default: null},
        sortDesc: {type: Boolean, default: false},
        tbodyTrAttr: {type: [Function, Object]},
        tbodyTrClass: {type: [Array, Function, String]},
    },
    watch: {
        filter(value) {
            this.model.filter = value
        },
        items(value) {
            this.model.totalRows = value.length
        },
        sortBy(value) {
            this.model.sortBy = value
        },
        sortDesc(value) {
            this.model.sortDesc = value
        },
    },
    created() {

        this.model.totalRows = this.items.length
    }
}
</script>